<script setup>
import { useProjectStore } from '@/store/project'
import { useBuildingStore } from '@/store/building'
import { useUnitStore } from '@/store/unit'

import BuildingChooser from '@/components/views/BuildingChooser.vue'
import UnitList from '@/components/views/UnitList.vue'
import LogoBanner from '@/components/project/LogoBanner.vue'

const { project: projectSlug } = useRoute().params

const projectStore = useProjectStore()
const buildingStore = useBuildingStore()
const unitStore = useUnitStore()

const { fetchProjectFields, fetchProjectStatuses, fetchProjectImages } = projectStore
const { fetchBuildings } = buildingStore
const { fetchUnits } = unitStore

await fetchProjectImages(projectSlug)
await fetchProjectFields(projectSlug)
await fetchProjectStatuses(projectSlug)
await fetchBuildings(projectSlug)
await fetchUnits(projectSlug)

const project = projectStore.project

const showBuildingChooser = ref(false)
let buildingChooserTimer = null

onMounted(() => {
    buildingChooserTimer = setTimeout(() => {
        showBuildingChooser.value = true
    }, 500)
})

onBeforeUnmount(() => {
    if (buildingChooserTimer) {
        clearTimeout(buildingChooserTimer)
        buildingChooserTimer = null
    }
})
</script>
<template>
    <ProjectHeader :project="project" />
    <div class="page-wrapper">
        <div class="interactive-component-wrapper">
            <div>
                <ClientOnly>
                    <BuildingChooser v-if="project && showBuildingChooser" />
                </ClientOnly>
            </div>
        </div>
        <div class="d-flex justify-center bg-grey-lighten-5">
            <div class="other-content dynamic-max-width">
                <div>
                    <ClientOnly>
                        <UnitList v-if="project">
                            <div class="pl-1 text-h6 text-capitalize">
                                {{ project.name }} - {{ `${$t('all')} ${$t('units')}` }}
                            </div>
                        </UnitList>
                    </ClientOnly>
                </div>
            </div>
        </div>
        <LogoBanner />
    </div>
</template>
<style>
.page-wrapper {
    padding: 12px;
}
</style>
